<template>
  <div class="yearBag">
    <div class="yearBagHeader">
      <div class="headerImg">
        <div class="imgYouKu"></div>
      </div>
    </div>
    <div class="yearBagContent">
      <div class="contentBg">
        <div class="contentBar">
          <div class="barInitiator" v-if="Initiator.nickname">
            <div class="Initiator">
              发起人: {{ Initiator.nickname }}
            </div>
            <div class="imgItem">
              <img :src="Initiator.avatar" alt="">
            </div>
          </div>
          <div class="barContent">
            <p>邀请3位好友助力</p>
            <p>立减20元</p>
            <div class="barImg"></div>
          </div>
          
        </div>
        <div class="contenImg">
          <div class="imgfriend">好友助力</div>
          <div class="imgItem" >
            <img :src="List[0].avatar" v-show="List[0].avatar">
            <div v-show="!List[0].avatar"></div>
          </div>
          <div class="bar"></div>
          <div class="imgItem">
            <img :src="List[1].avatar" v-show="List[1].avatar">
            <div v-show="!List[1].avatar"></div>
          </div>
          <div class="bar"></div>
          <div class="imgItem">
            <img :src="List[2].avatar" v-show="List[2].avatar">
            <div v-show="!List[2].avatar"></div>
          </div>
        </div>
        <div class="contentInput">
          <input class="inputBtn1" type="button" value="为好友助力" @click="forward()">
          <input class="inputBtn2" type="button" value="我也要" @click="forwardCreateAndShare(true)">
          <!-- <input class="inputBtn3" type="button" value="邀请好友" @click="forwardShare(true)"> -->
        </div>
        <div class="contentList">
          <div class="listTitle">好友</div>
          <div class="listItem" v-for="(item, index) in List" :key="index" v-show="item.avatar">
            <img :src="item.avatar" alt="">
            <span>{{item.nickname}}已为你助力</span>
          </div>
          <div class="listHint" v-if="!List[0].avatar&&!List[1].avatar&&!List[2].avatar">
            暂无好友助力
          </div>
        </div>
      </div>

    </div>
    <div class="hint" v-show="hintFlag">
      <div class="item">
        <p>恭喜您助力成功!</p>
        <div @click="hintFlag = !hintFlag">确定</div>
      </div>
    </div>
    <div class="hintShare" @click="hintShareFlag = !hintShareFlag" v-show="hintShareFlag">
      <div class="shareArrow"></div>
      <div class="shareFont">
        <div>请点击右上角</div>
        <div>将它发送给指定朋友</div>
        <div>或分享到朋友圈</div>
      </div>

    </div>
  </div>
</template>

<script>
import { Dialog, Notify } from 'vant'
import { getUrlRelativePath } from '../../assets/js/common'
import Param from '../../assets/js/Param.js'
export default {
  data() {
    return {
      user: {
        img1: null,
        img2: null,
        img3: null
      },
      List: [
        {avatar: '', nickname: ''},
        {avatar: '', nickname: ''},
        {avatar: '', nickname: ''}
      ],
      Initiator: {
        avatar: '', nickname: ''
      },
      Bg: [
        {imgUrl:require('../../assets/img/youkuCard/bg1.png')}
      ],
      hintFlag: false,
      hintShareFlag: false,
      jump_url: localStorage.getItem('self_jump_url') || null
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      // 分享提前加载
      if (localStorage.getItem('self_jump_url')) {
        this.forwardShare()
      }
      // 查询是否满足优惠

      if (localStorage.getItem('activity_id')) {
        this.$http.get('/test/v1/rc-activity/status-by-activity-id?' + Param.init({
          activity_id: localStorage.getItem('activity_id')
        }).re()).then((res) => {
          if (res.data.error === 0) {
            if (res.data.data.ponsor_user.length>0) {
              this.Initiator.avatar = res.data.data.ponsor_user[0].avatar
              this.Initiator.nickname = res.data.data.ponsor_user[0].nickname
            }
            if (res.data.data.help_user_list.length > 0 && res.data.data.help_user_list != '[]') {
              this.List = res.data.data.help_user_list
              if (res.data.data.help_user_list.length < 3) {
                for(let i = 0; i <= (3 - res.data.data.help_user_list.length);i++) {
                  this.List.push({
                    avatar: '', nickname: ''
                  })
                  
                }
              }
            }

            if (res.data.data.activity_status == 1 && localStorage.getItem('user_id') == res.data.data.ponsor_user[0].user_id) {
              Dialog.alert({
                title: '温馨提示',
                message: '您已获得助力优惠资格',
                confirmButtonText: '立即购买',
                closeOnClickOverlay: true
              }).then(() => {
                this.$router.push({
                  path: '/youKu/index'
                })
              })
            }

          }
        })
      }else {
        this.forwardCreateAndShare(false)
      }

    },
    forward() {
      this.$http.get('/test/v1/rc-activity/help?' + Param.init({
        activity_id: localStorage.getItem('activity_id')
      }).re()).then((res) => {
        if (res.data.error == 0) {
          this.hintFlag = !this.hintFlag
          this.init()
        } else {
          Dialog.alert({
            title: '温馨提示',
            message: res.data.msg,
            closeOnClickOverlay: true
          })
        }
      })
      
    },
    forwardCreateAndShare(flag) {
      this.$http.post('/test/v1/rc-activity/create?' + Param.init({}).re(), {
        jump_url_route: getUrlRelativePath()
      }, {
          emulateJSON: true
      }).then((res) => {
        if (res.data.error == 0) {
          this.jump_url = res.data.data.jump_url
          localStorage.setItem('self_jump_url', res.data.data.jump_url)
          localStorage.setItem('activity_id', res.data.data.activity_id)
          this.init()
          this.forwardShare(true)
        } else {
           Dialog.alert({
            title: '温馨提示',
            message: res.data.msg
          })
        }
      })
    },
    forwardShare(flag) {
      const _this = this
      if (flag) _this.hintShareFlag = !_this.hintShareFlag
      console.log(this.jump_url)
      this.wx.ready( () => {// 需在用户可能点击分享按钮前就先调用
        _this.wx.updateAppMessageShareData({ 
          title: '优酷半价年包', // 分享标题
          desc: '超低优酷，江湖支援，助我半价领取！', // 分享描述
          link: _this.jump_url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: 'https://www.china-m2m.com/imgs/imgYouKu2.png', // 分享图标
          success: function () {
            // 设置成功
            
          }
        })
      })
    }
  }
}
</script>

<style scoped lang="less">
  .yearBag {
    width: 100%;
    height: 100%;
    background: #5500DF;
    .yearBagHeader {
      width: 100%;
      height: 3.5rem;
      display: flex;
      align-items: center;
      justify-content: center;
      .headerImg {
        width: 100%;
        height: 100%;
        background: url("../../assets/img/youkuCard/forwardImg.png");
        background-size: 100% 100%;
        .imgYouKu {
          position: absolute;
          top: 0;
          left: 0;
          width: 1.1rem;
          height: .67rem;
          background: url("../../assets/img/youkuCard/imgYouKu.png");
          background-size: 100% 100%;
          margin: .2rem 0 0 .35rem;
        }
      }
    }
    .yearBagContent {
      width: 100%;
      padding: .3rem 0 0 0;
      background: #5500DF;
      .contentBg {
        width: 90%;
        background: #7423F9;
        border-radius: 20px 20px 20px 20px;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        box-sizing: border-box;
        .contentBar {
          display: flex;
          flex-direction: column;
          width: 100%;
          margin: 0 auto;
          align-items: center;
          padding: .2rem 0;
          box-sizing: border-box;
          position: relative;
          .barInitiator {
            .Initiator {
              position: absolute;
              left: .3rem;
              color: #FECE70;
              font-size: .26rem;
              letter-spacing: .01rem;
            }
            .imgItem {
              width: .85rem;
              height: .85rem;
              border-radius: 50%;
              border: .13rem solid #5500DF;
              background: #ccc;
              display: flex;
              justify-content: center;
              align-items: center;
              margin-bottom: .2rem;
              img {
                width: 100%;
                height: 100%;
                border-radius: 50%;
              }
            }
          }
          .barContent {
            position: relative;
            width: 78%;
            height: 1.2rem;
            border-radius: 33px;
            background: linear-gradient(180deg, #5500DF 0%, #4810A4 11%, #5200D4 50%, #3E00A2 100%);
            margin: 0 auto;
            text-align: center;
            color: #FECE70;
            letter-spacing: 2px;
            p:nth-child(1){
              height: .6rem;
              font-size: .26rem;
              line-height: .8rem;
            }
            p:nth-child(2){
              height: .6rem;
              font-size: .36rem;
            }
            .barImg {
              width: 2.16rem;
              height: 2.16rem;
              position: absolute;
              top: -.5rem;
              right: -.7rem;
              background: url("../../assets/img/youkuCard/forwardImg2.png");
              background-size: 100% 100%;
            }
          }

        }
        .contenImg {
          position: relative;
          width: 70%;
          margin: .2rem auto 0 auto;
          display: flex;
          align-items: center;
          .imgfriend {
            font-size: .26rem;
            position: absolute;
            top: -.3rem;
            left: -.8rem;
            color: #FECE70;
          }
          .imgItem {
            width: 1rem;
            height: 1rem;
            border-radius: 50%;
            border: .13rem solid #5500DF;
            background: #ccc;
            display: flex;
            justify-content: center;
            align-items: center;
            img {
              width: 100%;
              height: 100%;
              border-radius: 50%;
            }
            div {
              width: .68rem;
              height: .68rem;
              border-radius: 50%;
              background: url("../../assets/img/youkuCard/qs.png");
              background-size: 100% 100%;
            } 

          }
          .bar {
            width: .5rem;
            height: .13rem;
            background: #5500DF;
          }
        }

        .contentInput {
          width: 78%;
          margin: .2rem auto 0 auto;
          font-size: .26rem;
          font-weight: 500;
          .inputBtn1 {
            width: 100%;
            height: .6rem;
            border-radius: 20px;
            margin: .1rem 0;
            text-align: center;
            color: #FFFFFF;
            border: 0;
            background: #FF3D00;
            letter-spacing: 2px;
          }
          .inputBtn2 {
            width: 100%;
            height: .6rem;
            border-radius: 6px;
            background:#01CA9E;
            border: 0;
            margin: .1rem 0;
            color: #FFFFFF;
            letter-spacing: 2px;
          }
          .inputBtn3 {
            width: 45%;
            float: right;
            height: .6rem;
            border-radius: 6px;
            background: #FFCF70;
            border: 0;
            margin: .1rem 0;
            color: #FFFFFF;
            letter-spacing: 2px;
          }
        }

        .contentList {
          width: 80%;
          height: 3.1rem;
          background: #FFFFFF;
          margin: .5rem auto 0 auto;
          box-sizing: border-box;
          border-radius: 20px 20px 0 0 ;
          .listTitle {
            font-size: .28rem;
            color: #707070;
            text-align: center;
            padding: .2rem 0 0 0;
          }
          .listItem {
            display: flex;
            margin: .2rem .6rem;
            img {
              width: .5rem;
              height: .5rem;
              border-radius: 50%;
            }
            span {
              font-size: .26rem;
              line-height: .5rem;
              text-indent: .2rem;
              color: #707070;
            }
          }
          .listHint {
            margin: .2rem .6rem;
            text-align: center;
            font-size: .26rem;
            color: #707070;
          }
        }
      }
    }
    .hint {
      position: fixed;
      top: 0;
      left: 0;
      z-index: 1;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.7);
      display: flex;
      align-items: center;
      justify-content: center;
      .item {
        position: relative;
        width: 4.4rem;
        height: 5.86rem;
        background: url('../../assets/img/youkuCard/forwardImg3.png');
        background-size: 100% 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        p {
          font-size: .44rem;
          color: #FF3D00;
          letter-spacing: .01rem;
          font-weight: 600;
        }
        div  {
          position: absolute;
          bottom: .6rem;
          width: 2.5rem;
          height: .62rem;
          background: #FF3D00;
          color: #FFFFFF;
          line-height: .62rem;
          font-size: .3rem;
          text-align: center;
          border-radius: 20px;
          letter-spacing: .02rem;
        }
      }
    }
    .hintShare {
      position: fixed;
      top: 0;
      left: 0;
      z-index: 1;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.7);
      .shareArrow {
        position: absolute;
        right: .3rem;
        width: 1.2rem;
        height: 1.2rem;
        background: url("../../assets/img/youkuCard/forwardArrows.png");
        background-size: 100% 100%;
      }
      .shareFont {
        position: absolute;
        top: 1.2rem;
        right: .6rem;
        div {
          height: .45rem;
          font-size: .36rem;
          color: #FFFFFF;
          text-align: center;
          line-height: .45rem;
          letter-spacing: .03rem;
          font-family:FangSong;
        }
      }


    }
  }

</style>


// WEBPACK FOOTER //
// src/components/youKu/forward.vue